const items = [
  "Marino Centro Storico",
  "30 Minuti da Roma Termini",
  "5 Min da Castel Gandolfo",
  "20 Min dal Lago di Nemi",
  "Fraschette & Vigneti",
];

export default function Marquee() {
  const doubled = [...items, ...items];
  return (
    <div className="overflow-hidden border-b border-[#2a2825] py-4 bg-[#181614]" aria-hidden="true">
      <div className="marquee-track font-mono-tag text-xs uppercase tracking-[0.25em] text-[#c9944a] flex gap-12">
        {doubled.map((item, i) => (
          <span key={i} className="flex gap-12 items-center">
            <span>{item}</span>
            <span>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
